import React from "react";
import * as styles from "./MethodIcon.module.scss";
import { cx } from "class-variance-authority";

export const MethodIcon = ({
  children,
  className,
}: { children: React.ReactNode; className?: string }) => {
  return <div className={cx(styles.methodIcon, className)}>{children}</div>;
};
